import { create } from 'zustand'

export default create((set, get) => ({
  collection: [],
  fetching: false,
  fetch: async () => {
    if (get().fetching) return
    if (get().collection.length > 0) return
    set({ fetching: true })
    const response = await fetch('/regions.json')
    const data = await response.json()
    set({ collection: data, fetching: false })
  },
}))
